import React from 'react';
import BestSellingItems from '../../components/BestSellingItems';

const BestSellingItemsPage = () => {
    return (
        <div className="">
            <BestSellingItems />
        </div>
    );
};

export default BestSellingItemsPage;
